<template>
  <div
    class="library-file"
    :class="{
      favorited: favoriteCheck,
      selected: selected,
      'library-file--disabled': disableAll,
    }"
    @click="!disableAll ? $emit('select-file', id) : undefined"
  >
    <div
      class="library-file__thumbnail--wrap with-overlay"
      :class="processing ? 'processing' : ''"
    >
      <v-progress-linear
        v-if="!disableAll && hoverLoader"
        background-color="rgba(255,255,255,0.3)"
        class="library-file__loader"
        :value="hoverLoader"
      ></v-progress-linear>
      <img
        v-if="!processing"
        class="library-file__thumbnail"
        :src="thumbnailUrl || placeholder(fileTypeId)"
      />
      <v-progress-circular
        v-else
        class="library-file__thumbnail--loader"
        size="32"
        indeterminate
        color="bhBlue3"
        :width="3"
      ></v-progress-circular>
      <template v-if="!disableAll">
        <div class="library-file__thumbnail--buttons">
          <v-btn
            v-if="favoriteProfileId"
            text
            icon
            elevation="0"
            class="favorite"
            @click.stop="$emit('toggleFavorite', id, !favoriteCheck)"
            @mouseover.stop="$emit('stopHoverPopup')"
          >
            <v-icon size="16" v-if="favoriteCheck">bhi-heart-filled</v-icon>
            <v-icon size="16" v-else>bhi-heart</v-icon>
          </v-btn>
          <!-- following filters are commented out as they are currently inefficient with 1000+ files -->
          <!-- <v-btn
          v-if="!locked"
          text
          icon
          elevation="0"
          class="mindset"
          :class="mindsetCheck ? 'selected' : ''"
          @click.stop="toggleTag(50)"
          @mouseover.stop="$emit('stopHoverPopup')"
        >
          <v-icon size="16">bhi-lightbulb</v-icon>
        </v-btn>
        <v-btn
          v-if="!locked"
          text
          icon
          elevation="0"
          class="movement"
          :class="movementCheck ? 'selected' : ''"
          @click.stop="toggleTag(51)"
          @mouseover.stop="$emit('stopHoverPopup')"
        >
          <v-icon size="16">bhi-pulse</v-icon>
        </v-btn>
        <v-btn
          v-if="!locked"
          text
          icon
          elevation="0"
          class="meals"
          :class="mealsCheck ? 'selected' : ''"
          @click.stop="toggleTag(49)"
          @mouseover.stop="$emit('stopHoverPopup')"
        >
          <v-icon size="16">bhi-meal</v-icon>
        </v-btn> -->
        </div>
        <div
          v-if="fileTypeId == 19"
          class="library-file__thumbnail--play-overlay"
        >
          <v-btn
            text
            icon
            elevation="0"
            class="play"
            @click.stop="openBigImage"
            @mouseover.stop="$emit('stopHoverPopup')"
            @mouseover.native.stop="$emit('stopHoverPopup')"
          >
            <v-icon size="48">bhi-play-circle</v-icon>
          </v-btn>
        </div>
        <v-btn
          v-if="fileTypeId == 18 || fileTypeId == 19 || fileTypeId == 20"
          text
          icon
          elevation="0"
          class="expand"
          @click.stop="openBigImage"
          @mouseover.stop="$emit('stopHoverPopup')"
          @mouseover.native.stop="$emit('stopHoverPopup')"
        >
          <v-icon size="16">bhi-expand</v-icon>
        </v-btn>
        <v-btn
          v-else-if="!locked"
          text
          icon
          elevation="0"
          class="download"
          @click.stop="downloadFile"
          @mouseover.stop="$emit('stopHoverPopup')"
          @mouseover.native.stop="$emit('stopHoverPopup')"
        >
          <v-icon size="16">bhi-download</v-icon>
        </v-btn>
      </template>
      <library-more-menu
        v-if="!disableAll && editable"
        :additional-class="'library-file__more--menu'"
        :id="id"
        :version="version"
        :name="name"
        :menu="menuHandler"
        :locked="locked"
        :thumbnailChangeAvailable="true"
        :forwardingToJournalAvailable="isJournalFolder"
        :modalDirectory="modalDirectory"
        :showScheduleMessageDialog="showScheduleMessageDialog"
        :showCreateExercise="showCreateExercise"
        :showCreateActivity="showCreateActivity"
        :showSendMessage="showSendMessage"
        @changeMenuType="changeMenu"
        @openScheduleMessageDialog="openScheduleMessageDialog"
        @openCreateExerciseDialog="openCreateExerciseDialog"
        @openCreateActivityDialog="openCreateActivityDialog"
        @openSendMessageDialog="openSendMessageDialog"
        @mouseover.stop="$emit('stopHoverPopup')"
        @mouseover.native.stop="$emit('stopHoverPopup')"
        v-on="$listeners"
      ></library-more-menu>
    </div>
    <library-author-meta
      :creationDate="creationDate"
      :createdById="createdById"
      :type="fileTypeId"
      :isLoading="isLoading"
    ></library-author-meta>
    <v-tooltip v-if="name.length > 35" bottom open-delay="200">
      <template v-slot:activator="{ on, attrs }">
        <h5 v-if="name.length <= 35">{{ name }}</h5>
        <h5 v-bind="attrs" v-on="on" v-else>
          {{ name.substring(0, 35) + '...' }}
        </h5>
      </template>
      <span>{{ name }}</span>
    </v-tooltip>
    <h5 v-else>{{ name }}</h5>
  </div>
</template>
<script>
import LibraryMoreMenu from '@/components/library/LibraryMoreMenu.vue'
import LibraryAuthorMeta from '@/components/library/LibraryAuthorMeta.vue'
export default {
  name: 'LibraryFile',
  components: {
    LibraryMoreMenu,
    LibraryAuthorMeta,
  },
  props: {
    thumbnailUrl: {
      type: [String, Boolean],
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    creationDate: {
      type: String,
      default: '',
    },
    createdById: {
      type: Number,
      default: 0,
    },
    version: {
      type: Number,
      default: 0,
    },
    favoriteProfileId: {
      type: [Boolean, Array],
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    modalDirectory: {
      type: Object,
      default: () => ({}),
    },
    fileTypeId: {
      type: [Boolean, Number],
      default: false,
    },
    labels: {
      type: Array,
      default: () => [],
    },
    profileId: {
      type: [Boolean, String],
      default: false,
    },
    messageResource: {
      type: [Boolean, Object],
      default: false,
    },
    getResource: {
      type: Function,
      default: () => null,
    },
    hoverLoader: {
      type: Number,
      default: 0,
    },
    processing: {
      type: Boolean,
      default: false,
    },
    isJournalFolder: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showScheduleMessageDialog: {
      type: Boolean,
      default: false,
    },
    showCreateExercise: {
      type: Boolean,
      default: false,
    },
    showCreateActivity: {
      type: Boolean,
      default: false,
    },
    showSendMessage: {
      type: Boolean,
      default: false,
    },
    disableAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuHandler: false,
      newLabels: [],
    }
  },
  watch: {
    labels(val) {
      if (val) this.newLabels = val
    },
  },
  computed: {
    favoriteCheck() {
      if (
        Array.isArray(this.favoriteProfileId) &&
        this.favoriteProfileId.includes(parseInt(this.profileId))
      )
        return true
      else return false
    },
    mindsetCheck() {
      return this.labels.includes(50)
    },
    movementCheck() {
      return this.labels.includes(51)
    },
    mealsCheck() {
      return this.labels.includes(49)
    },
    hover() {
      return this.hoverLoader[this.id] ? this.hoverLoader[this.id] : 0
    },
  },
  methods: {
    changeMenu(type) {
      this.menuHandler = type
    },
    openScheduleMessageDialog() {
      this.$emit('openScheduleMessageDialog')
    },
    openCreateExerciseDialog() {
      this.$emit('openCreateExerciseDialog')
    },
    openCreateActivityDialog() {
      this.$emit('openCreateActivityDialog')
    },
    openSendMessageDialog() {
      this.$emit('openSendMessageDialog')
    },
    downloadFile() {
      this.$emit('download-file', { id: this.id })
    },
    toggleTag(labelId) {
      const index = this.newLabels.indexOf(labelId)
      if (index != -1) this.newLabels.splice(index, 1)
      else this.newLabels.push(labelId)
      this.$emit('toggleTag', this.id, this.version, this.newLabels) // waiting for api info
    },
    placeholder(fileTypeId) {
      let image = 'placeholder_other.png'
      switch (fileTypeId) {
        case 17:
          image = 'placeholder_other.png'
          break
        case 18:
          image = 'placeholder_image.png'
          break
        case 19:
          image = 'placeholder_video.png'
          break
        case 20:
          image = 'placeholder_pdf.png'
          break
        case 21:
          image = 'placeholder_doc.png'
          break
        case 22:
          image = 'placeholder_presentation.png'
          break
        case 23:
          image = 'placeholder_sheet.png'
          break
        case 52:
          image = 'placeholder_note.png'
          break
        default:
          break
      }
      return require('@/assets/' + image)
    },
    async openBigImage() {
      if (this.id) {
        this.$emit('show-bigger-image', {
          url: null,
          file: null,
          name: null,
          mlResourceUrl: null,
        }) // Show dialog while getting new s3 file url
        await this.getResource({ id: this.id })
      }
      let type = 1
      switch (this.messageResource.fileTypeId) {
        case 18:
          type = 1
          break
        case 19:
          type = 3
          break
        case 20:
          type = 5
          break
        default:
          type = 1
          break
      }
      const title =
        this.messageResource.title.replace(/[/\\?%*:|"<>]/g, '-') +
        '.' +
        this.messageResource.name
          .split('.')
          .pop()
          .trim()
          .toLowerCase()
      this.$emit('show-bigger-image', {
        url: this.messageResource.fileUrl,
        name: title,
        file: this.messageResource.previewUrl,
        mlResourceUrl: this.messageResource.id,
        type: type,
      })
    },
  },
}
</script>

<style lang="scss">
.library-file {
  width: 170px;
  height: 228px;
  border-radius: 8px;
  border: 1px solid $bh-white;
  padding: 5px;
  margin: 3px 3px 12px;
  -webkit-transition-duration: 150ms;
  -moz-transition-duration: 150ms;
  -ms-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  cursor: pointer;

  &--disabled {
    opacity: 0.5;
    cursor: initial !important;
  }

  &:not(.library-file--disabled):hover {
    border-color: $bh-blue--4;
    .library-file {
      &__thumbnail {
        &--wrap {
          &.with-overlay::after {
            opacity: 1;
          }
          .v-btn {
            opacity: 1;
          }
        }
      }
    }
  }
  &.favorited {
    .v-btn.favorite {
      .v-icon {
        color: $bh-white;
      }
      background: $bh-blue;
      opacity: 1;
    }
  }
  &.selected {
    border-color: $bh-blue--2;
    background: $bh-blue--4;
  }
  &__loader {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
    transition: 0.2s linear !important;
    .v-progress-linear__background,
    .v-progress-linear__buffer,
    .v-progress-linear__determinate {
      transition: 0.2s linear !important;
    }
  }
  &__thumbnail {
    width: 100%;
    height: 100%;
    position: relative;
    object-fit: cover;
    &--wrap {
      height: 120px;
      margin-bottom: 12px;
      overflow: hidden;
      border-radius: 8px;
      position: relative;
      &.processing {
        background: $bh-gray--6;
      }
      &.with-overlay {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 0;
          -webkit-transition-duration: 150ms;
          -moz-transition-duration: 150ms;
          -ms-transition-duration: 150ms;
          -o-transition-duration: 150ms;
          transition-duration: 150ms;
          opacity: 0;
          background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.5) 0%,
              rgba(0, 0, 0, 0) 37.08%
            ),
            rgba(0, 0, 0, 0.1);
        }
      }
      .v-btn {
        position: absolute;
        top: 6px;
        right: 7px;
        width: 22px;
        height: 22px;
        z-index: 1;
        -webkit-transition-duration: 150ms;
        -moz-transition-duration: 150ms;
        -ms-transition-duration: 150ms;
        -o-transition-duration: 150ms;
        transition-duration: 150ms;
        opacity: 0;
        &:hover {
          background: rgba(255, 255, 255, 0.5);
          .v-icon {
            color: $bh-blue;
          }
        }
        &.favorite {
          .v-icon {
            margin-top: 2px;
          }
        }
        &.expand,
        &.download {
          top: auto;
          bottom: 7px;
          border-radius: 50%;
        }
        &.play {
          top: 50%;
          left: 50%;
          right: auto;
          transform: translate3d(-50%, -50%, 0px);
          opacity: 1;
          width: 48px;
          height: 48px;
          .v-icon {
            width: 48px;
            height: 48px;
          }
        }
        .v-icon {
          color: $bh-white;
        }
      }
    }
    &--play-overlay {
      position: absolute;
      background: rgba(0, 0, 0, 0.2);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    &--buttons {
      width: 22px;
      left: 7px;
      position: absolute;
      top: 6px;
      z-index: 1;
      .v-btn {
        position: relative !important;
        border-radius: 6px;
        top: 0;
        left: 0;
        right: 0;
        margin-bottom: 6px;
        &:hover {
          opacity: 1;
        }
        &.selected {
          opacity: 1;
          &:hover {
            .v-icon {
              color: $bh-white !important;
            }
          }
        }
        &.movement {
          &:hover {
            .v-icon {
              color: $bh-green--light;
            }
          }
          &.selected {
            background: $bh-green--light;
          }
        }
        &.meals {
          &:hover {
            .v-icon {
              color: $bh-blue--2;
            }
          }
          &.selected {
            background: $bh-blue--2;
          }
        }
        &.mindset {
          &:hover {
            .v-icon {
              color: $bh-red--light;
            }
          }
          &.selected {
            background: $bh-red--light;
          }
        }
      }
    }
    &--loader {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0px);
    }
  }
  &__meta {
    display: flex;
    margin-bottom: 10px;
    &-icon {
      width: 24px;
      height: 24px;
      text-align: center;
      border-radius: 6px;
      overflow: hidden;
      margin-right: 6px;
      &.type-clip {
        background: $bh-red;
      }
      &.type-photo {
        background: $bh-yellow;
      }
      .v-icon {
        color: $bh-white;
        font-size: 12px;
      }
    }
    &-text {
      display: flex;
      flex-direction: column;
      max-height: 36px;
      .date {
        display: block;
        color: $bh-gray--2;
        font-size: 10px;
        line-height: 13px;
      }
      .name {
        color: $bh-gray;
        font-size: 8px;
        line-height: 10px;
      }
    }
  }
  h5 {
    color: $bh-black;
    max-height: 2.5em;
    overflow: hidden;
  }
}
</style>
